import { McOption, McSelect } from '@maersk-global/mds-react-wrapper';
import React, { FunctionComponent, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { AppRoutes } from '../../../config/routes';
import { terminalCodeAtom } from '../../../state';
import FormattedMessage from '../../common/FormattedMessage';
import { getTerminalByCode, terminals } from '../../common/helpers/terminals';
import useAuth from '../../common/hooks/useAuth';
import { useRedirectToRoute } from '../../common/hooks/useRedirectToRoute';
import Parameters from '../components/parameters';

const WeatherContainer: FunctionComponent = () => {
  const [selectedTerminal, setSelectedTerminal] = useRecoilState(terminalCodeAtom);
  const { userData } = useAuth();
  const { id } = useParams<{ id: string }>();
  const redirectToRoute = useRedirectToRoute();

  useEffect(() => {
    if (!id) {
      return;
    }
    setSelectedTerminal(id);
  }, [id, setSelectedTerminal]);

  const handleSelectChange = async (selectedCode: string) => {
    if (!selectedCode) {
      return;
    }
    setSelectedTerminal(selectedCode);
    redirectToRoute(AppRoutes.WeatherId, { id: selectedCode }, { replace: true });
  };

  return (
    <div className="WeatherContainer">
      <div className="CapacityIdContainer__dropdown-wrapper">
        <FormattedMessage id="updateRuleDrawerFormTerminal" />
        <div className="CapacityIdContainer__dropdown-wrapper__content">
          <McSelect
            className="CapacityIdContainer__dropdown"
            hiddenlabel
            placeholder="Select terminal"
            value={selectedTerminal}
            optionselected={(e) => {
              handleSelectChange((e.target as HTMLInputElement).value);
            }}
            name="terminal"
          >
            {userData?.terminalCodes &&
              terminals
                .filter((terminal) => userData.terminalCodes.includes(terminal.code))
                .map((terminal) => (
                  <McOption key={terminal.code} value={terminal.code}>
                    {terminal.name}
                  </McOption>
                ))}
          </McSelect>
        </div>
      </div>
      <h1 className="CapacityIdContainer__heading">
        {selectedTerminal
          ? `${getTerminalByCode(selectedTerminal)?.name} (${getTerminalByCode(selectedTerminal)?.code})`
          : ''}
      </h1>

      {selectedTerminal && <Parameters selectedTerminal={selectedTerminal} />}
    </div>
  );
};

export default WeatherContainer;
